import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { UserinfoService } from "../service/userinfo.service";
import { KraftpaketService } from "../service/kraftpaket.service";
import { MatSnackBar } from '@angular/material';
import { HistlistService } from "../service/histlist.service";
import { CsvUploadService } from '../service/csv-upload.service';
import { DataTable } from 'primeng/primeng';
import { UserData } from '../../../config/globals/userData.global';
import { TeilpaketStatus } from './types/TeilpaketStatus';
import { UserRole } from "../type/UserRole";
// Bearbeitungsmodus der Seite
// Anzeige Teilpaketübersicht (Inhalt aus DB-Tabelle MP_ORIGIN)
// Anzeige Teilpaket-Details (csv-Datei - DB-Tabelle MP_HIST)
// Anzeige Datei-Upload
export var PageModeEnum;
(function (PageModeEnum) {
    PageModeEnum[PageModeEnum["mpListe"] = 0] = "mpListe";
    PageModeEnum[PageModeEnum["mpDetail"] = 1] = "mpDetail";
    PageModeEnum[PageModeEnum["mpUpload"] = 2] = "mpUpload";
})(PageModeEnum || (PageModeEnum = {}));
function delayFunc(t) {
    return new Promise(function (resolve) {
        setTimeout(resolve, t);
    });
}
function pollUntilDone(url, interval, timeout, appMaklerpaket, isEinspielen) {
    var start = Date.now();
    function run(appMaklerpaket) {
        return appMaklerpaket.csvUploadService.uploadMakpakKraftCheckResult(appMaklerpaket.selectedTeilpaket, appMaklerpaket.userinfo.bensl, url).subscribe(function (dataResult) {
            if (JSON.stringify(dataResult).indexOf("Maklerpaket in Bearbeitung") == -1) {
                if (!appMaklerpaket.userData.isStageP()) {
                    console.log("Result available :" + dataResult);
                    appMaklerpaket.requestLog = JSON.stringify(dataResult).split("}}]");
                    if (!appMaklerpaket.setting.element.dynamicDownload) {
                        appMaklerpaket.setting.element.dynamicDownload = document.createElement('a');
                    }
                    var element = appMaklerpaket.setting.element.dynamicDownload;
                    var fileType = 'text/json';
                    element.setAttribute('href', "data:" + fileType + ";charset=utf-8," + encodeURIComponent(appMaklerpaket.requestLog[1]));
                    element.setAttribute('download', 'logKraft');
                    var event = new MouseEvent("click");
                    element.dispatchEvent(event);
                    console.log("Sent");
                    //rausgenommen durch p070582 - appMaklerpaket.saveCheckedJson(dataResult._body);
                }
                //Liste der Teilpakete neu laden, da sich der Status u.U. geändert hat
                if (isEinspielen) {
                    appMaklerpaket.loadTeilpakete(false);
                    return dataResult;
                }
                else {
                    appMaklerpaket.userData.setBiproDataLoaded(true);
                    //Liste der Teilpakete neu laden, da sich der Status u.U. geändert hat
                    appMaklerpaket.loadTeilpakete(false).then(function () {
                        //neu laden - insbesondere damit die farbige Markierung der editierten Zellen wieder verschwindet
                        return appMaklerpaket.loadTeilpaketDetails(appMaklerpaket.selectedTeilpaket.id);
                    });
                    return dataResult;
                }
            }
            else {
                if (timeout !== 0 && Date.now() - start > timeout) {
                    console.log("Not retrying due to timeout");
                    throw new Error("timeout error on pollUntilDone");
                }
                else {
                    console.log("Result not ready yet. Retrying soon.");
                    // run again with a short delay
                    return delayFunc(interval).then(run(appMaklerpaket));
                }
            }
        });
    }
    return run(appMaklerpaket);
}
var AppMaklerpaketKraft = /** @class */ (function () {
    function AppMaklerpaketKraft(userinfoService, kraftpakService, HistListService, csvUploadService, snackBar, userData) {
        this.userinfoService = userinfoService;
        this.kraftpakService = kraftpakService;
        this.HistListService = HistListService;
        this.csvUploadService = csvUploadService;
        this.snackBar = snackBar;
        this.userData = userData;
        this.paketBearbeitungDisabled = true;
        this.paketBearbeitungDisabledPruefOk = true;
        this.paketBearbeitungDisabledInFreigabe = true;
        this.paketBearbeitungDisabledFreigegeben = true;
        this.paketLoeschenDisabled = true;
        this.importBtAnzeigen = false;
        this.loeschenBtAnzeigen = false;
        this.uebergabeBtAnzeigen = false;
        this.zuruecksendenBtAnzeigen = false;
        this.einspielenBtAnzeigen = false;
        this.ablehnenBtAnzeigen = false;
        this.freigebenBtAnzeigen = false;
        this.pageModes = PageModeEnum;
        this.mode = this.pageModes.mpListe;
        this.showHistList = false;
        this.displayDialog = false;
        this.deleteDialog = false;
        this.einspielenDialog = false;
        this.UserRole = UserRole; // necessary to be able use it in html-component
        this.setting = {
            element: {
                dynamicDownload: null
            }
        };
        this.labelTeilpaketeTabelleHeader = [
            { field: 'beschreibung', label: 'Paketname' },
            { field: 'dateiname', label: 'Dateiname' },
            { field: 'vermittlernummer', label: 'Vermittler-Nr' },
            { field: 'status', label: 'Status' },
            { field: 'statusdatum', label: 'Statusdatum' },
            { field: 'loeschdatum', label: 'Löschdatum' },
            { field: 'anzahlGesamt', label: 'Anzahl Vorgänge' },
            { field: 'anzahlGesperrt', label: 'Gesperrte Vorgänge' },
            { field: 'anzahlNok', label: 'Fehlerhafte Vorgänge' },
            { field: 'sumVorKh', label: 'Beitragseinnahmen KH' },
            { field: 'sumVorTk', label: 'Beitragseinnahmen TK' },
            { field: 'sumVorVk', label: 'Beitragseinnahmen VK' },
            { field: 'sumVorVuSonstige', label: 'Beitrag VorVU Sonstiges' },
            { field: 'sumVorVuInsaUnf', label: 'Beitrag VorVU Insassen-Unfall' }
        ];
        this.labelTeilpaketeTabelleHeaderMakler = [
            { field: 'beschreibung', label: 'Paketname' },
            { field: 'dateiname', label: 'Dateiname' },
            { field: 'vermittlernummer', label: 'Vermittler-Nr' },
            { field: 'status', label: 'Status' },
            { field: 'statusdatum', label: 'Statusdatum' },
            { field: 'loeschdatum', label: 'Löschdatum' },
            { field: 'anzahlGesamt', label: 'Anzahl Vorgänge' },
            { field: 'anzahlGesperrt', label: 'Gesperrte Vorgänge' },
            { field: 'anzahlNok', label: 'Fehlerhafte Vorgänge' }
        ];
    }
    AppMaklerpaketKraft.prototype.ngOnInit = function () {
        this.statusAllList = Object.values(TeilpaketStatus).map(function (val) { return ({ label: val, value: val }); });
        this.userinfo = this.userinfoService.getUserinfo();
        if (this.userinfo.rolle == UserRole.MAKLER) {
            //Makler hat neben 'Teilpaket anezigen'-Button nur den Button 'Teilpaket übergeben'
            this.importBtAnzeigen = false;
            this.loeschenBtAnzeigen = true;
            this.uebergabeBtAnzeigen = true;
            this.zuruecksendenBtAnzeigen = false;
            this.einspielenBtAnzeigen = false;
            this.ablehnenBtAnzeigen = false;
            this.freigebenBtAnzeigen = false;
        }
        if (this.userinfo.rolle == UserRole.MAKLERBETREUER) {
            this.importBtAnzeigen = true;
            this.loeschenBtAnzeigen = true;
            this.uebergabeBtAnzeigen = true;
            this.zuruecksendenBtAnzeigen = false;
            this.einspielenBtAnzeigen = false;
            this.ablehnenBtAnzeigen = false;
            this.freigebenBtAnzeigen = false;
        }
        if (this.userinfo.rolle == UserRole.PRODUKTGEBER) {
            this.importBtAnzeigen = true;
            this.loeschenBtAnzeigen = false;
            this.uebergabeBtAnzeigen = false;
            this.zuruecksendenBtAnzeigen = true;
            this.einspielenBtAnzeigen = true;
            this.ablehnenBtAnzeigen = true;
            this.freigebenBtAnzeigen = true;
        }
        this.displayDialog = false;
        this.deleteDialog = false;
        this.einspielenDialog = false;
        //laden der Teilpakete
        this.loadTeilpakete(false);
        this.mode = this.pageModes.mpListe;
    };
    AppMaklerpaketKraft.prototype.errorHandling = function (error) {
        console.log(error);
        //reset
        this.displayDialog = false;
        this.deleteDialog = false;
        this.einspielenDialog = false;
        //laden der Teilpakete
        this.loadTeilpakete(true);
        this.mode = this.pageModes.mpListe;
    };
    AppMaklerpaketKraft.prototype.uploadStatus = function (uploadStatus) {
        this.loadTeilpakete(false);
        if (uploadStatus.result.length > 0) {
            this._teilpaketDetails = uploadStatus.result;
            this.selectedTeilpaket = uploadStatus.newTeilpaket;
            this.mode = this.pageModes.mpDetail;
        }
        else {
            this.snackBar.open("Teilpaket-Details können nicht geladen werden!", null, { duration: 2000, panelClass: ["bgc-red-400"] });
            this.mode = this.pageModes.mpListe;
        }
    };
    AppMaklerpaketKraft.prototype.anzeigeMpliste = function () {
        console.log("Paketübersicht anzeigen");
        this.mode = this.pageModes.mpListe;
        this._teilpaketDetails = null;
    };
    AppMaklerpaketKraft.prototype.anzeigeTeilpaket = function () {
        if (this.selectedTeilpaket && !this.paketBearbeitungDisabled) {
            this.loadTeilpaketDetails(this.selectedTeilpaket.id);
        }
    };
    AppMaklerpaketKraft.prototype.loescheTeilpaket = function () {
        if (this.selectedTeilpaket && !this.paketLoeschenDisabled) {
            this.deleteDialog = true;
        }
    };
    AppMaklerpaketKraft.prototype.paketLoeschen = function () {
        this.deleteDialog = false;
        if (this.selectedTeilpaket && !this.paketLoeschenDisabled) {
            this.loescheTeilpaketAusListe(this.selectedTeilpaket.id);
        }
    };
    AppMaklerpaketKraft.prototype.paketNichtLoeschen = function () {
        this.deleteDialog = false;
    };
    AppMaklerpaketKraft.prototype.einspielenTeilpaketWithId = function (teilpaketId) {
        if (teilpaketId !== this.selectedTeilpaket.id) {
            throw new Error("Teilpaket zum einspielen ist nicht das gleiche wie das markierte.");
        }
        this.einspielenDialog = true;
    };
    AppMaklerpaketKraft.prototype.einspielenTeilpaket = function () {
        if (this.selectedTeilpaket && !this.paketBearbeitungDisabledFreigegeben) {
            this.einspielenDialog = true;
        }
    };
    AppMaklerpaketKraft.prototype.paketEinspielen = function () {
        this.einspielenDialog = false;
        if (this.selectedTeilpaket && !(this.paketBearbeitungDisabledFreigegeben && this.paketBearbeitungDisabledInFreigabe)) {
            this.paketAusListeEinspielen();
        }
    };
    AppMaklerpaketKraft.prototype.paketNichtEinspielen = function () {
        this.einspielenDialog = false;
    };
    AppMaklerpaketKraft.prototype.importMaklerpaket = function () {
        this.mode = this.pageModes.mpUpload;
    };
    AppMaklerpaketKraft.prototype.uebergebeTeilpaket = function () {
        if (this.selectedTeilpaket && !this.paketBearbeitungDisabledPruefOk) {
            console.log("Das ausgewählte Teilpaket wird vom Makler an Produktgeber / Maklervertrieb zum Einspielen weitergeleitet!");
            this.paketUpdateStatus(TeilpaketStatus.IN_FREIGABE);
        }
    };
    AppMaklerpaketKraft.prototype.freigebenTeilpaket = function () {
        if (this.selectedTeilpaket && !this.paketBearbeitungDisabledInFreigabe) {
            console.log("Das ausgewählte Teilpaket wird vom Produktgeber freigegeben!");
            this.paketUpdateStatus(TeilpaketStatus.FREIGEGEBEN);
        }
    };
    AppMaklerpaketKraft.prototype.zuruecksendenTeilpaket = function () {
        if (this.selectedTeilpaket && !this.paketBearbeitungDisabledInFreigabe) {
            console.log("Das ausgewählte Teilpaket soll zur Bearbeitung zurück an den Makler!");
            this.paketUpdateStatus(TeilpaketStatus.BEARBEITET);
        }
    };
    AppMaklerpaketKraft.prototype.ablehnenTeilpaket = function () {
        if (this.selectedTeilpaket && !this.paketBearbeitungDisabledInFreigabe) {
            console.log("Das ausgewählte Teilpaket wurde abgelehnt!");
            this.paketUpdateStatus(TeilpaketStatus.ABGELEHNT);
        }
    };
    AppMaklerpaketKraft.prototype.loadHistList = function (event) {
        console.log("hallo - loadHistList(event) " + this.selectedTeilpaket.id);
        this.id_origin = this.selectedTeilpaket.id;
        console.log("hallo - loadHistList(event) " + this.id_origin);
        this.showHistList = true;
    };
    AppMaklerpaketKraft.prototype.isHistListVisible = function (show) {
        this.showHistList = show;
    };
    AppMaklerpaketKraft.prototype.onTeilpaketSelect = function (event) {
        var _this = this;
        this.kraftpakService.sendIdInUse(this.selectedTeilpaket.id)
            .subscribe(function (result) {
            console.log("thank you for sending: " + result);
        }, function (error) {
            _this.snackBar.open("Fehler bei sendInUse aufgetreten!", null, { duration: 2000, panelClass: ["bgc-red-400"] });
            _this.errorHandling(error);
        });
        console.log("teilpaket ausgewählt: " + this.selectedTeilpaket.id);
        this.paketBearbeitungDisabled = false;
        this.paketLoeschenDisabled = this.selectedTeilpaket.status == TeilpaketStatus.EINGESPIELT;
        this.paketBearbeitungDisabledPruefOk = this.selectedTeilpaket.status != TeilpaketStatus.GEPRUEFT_OK;
        this.paketBearbeitungDisabledInFreigabe = this.selectedTeilpaket.status != TeilpaketStatus.IN_FREIGABE;
        this.paketBearbeitungDisabledFreigegeben = this.selectedTeilpaket.status != TeilpaketStatus.FREIGEGEBEN;
    };
    AppMaklerpaketKraft.prototype.onTeilpaketUnselect = function (event) {
        console.log("teilpaket abgewählt: " + event.data.id);
        this.paketBearbeitungDisabled = true;
        this.paketLoeschenDisabled = true;
        this.paketBearbeitungDisabledPruefOk = true;
        this.paketBearbeitungDisabledInFreigabe = true;
    };
    AppMaklerpaketKraft.prototype.loadUpForCheck = function (packageList) {
        var _this = this;
        this.csvUploadService.uploadMakpakKraftForCheck(packageList, this.selectedTeilpaket, this.userinfo.bensl, '/makpak/getqoute')
            .subscribe(function (res) {
            if (JSON.stringify(res).indexOf("Datei ist in Arbeit") > -1) {
                _this.snackBar.open("Teilpaket wird bereits von einem anderen Anwender bearbeitet.", null, { duration: 8000, panelClass: ["bgc-red-400"] });
                _this.userData.setBiproDataLoaded(true);
            }
            else {
                //check every 1s for up to 10 min
                pollUntilDone("/makpak/getresult", 1000, 10 * 60 * 1000, _this, false);
            }
        }, function (error) {
            _this.snackBar.open("Es ist ein Fehler beim Prüfen des Teilpakets aufgetreten!", null, { duration: 2000, panelClass: ["bgc-red-400"] });
            _this.errorHandling(error);
        });
    };
    AppMaklerpaketKraft.prototype.loadUpForSave = function (packageList) {
        var _this = this;
        this.csvUploadService.uploadMakpakKraftForSave(packageList, this.selectedTeilpaket, this.userinfo.bensl)
            .subscribe(function (res) {
            if (JSON.stringify(res).indexOf("Datei ist in Arbeit") > -1) {
                _this.snackBar.open("Teilpaket wird bereits von einem anderen Anwender bearbeitet.", null, { duration: 8000, panelClass: ["bgc-red-400"] });
                _this.userData.setBiproDataLoaded(true);
            }
            else {
                _this.loadTeilpakete(false);
                _this.loadTeilpaketDetails(_this.selectedTeilpaket.id);
            }
        }, function (error) {
            var errorMessageDefault = "Es ist ein Fehler beim Speichern des Teilpakets aufgetreten!";
            _this.snackBar.open(errorMessageDefault, null, { duration: 3000, panelClass: ["bgc-red-400"] });
            _this.errorHandling(error);
        });
    };
    AppMaklerpaketKraft.prototype.loadTeilpakete = function (loadInCaseOfError) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!loadInCaseOfError) {
                            //ToDo what is the reason of loadInCaseOfError?
                        }
                        //this.kraftpakService.getTeilpakete().subscribe((teilpaketeAusDB) => {
                        return [4 /*yield*/, this.kraftpakService.getTeilpaketeFiltered()
                                .then(function (teilpaketeAusDB) {
                                _this.snackBar.open("Liste der Teilpakete wird geladen!", null, { duration: 1000, panelClass: ["bgc-green-400"] });
                                _this._teilpakete = teilpaketeAusDB;
                                console.log("loadTeilpakete - ausgeführt");
                                if (_this._teilpakete.length > 0) {
                                    console.log("loadTeilpakete - Teilpakete gefunden");
                                    //das ursprüngliche wieder selektieren
                                    for (var _i = 0, _a = _this._teilpakete; _i < _a.length; _i++) {
                                        var teilpaket = _a[_i];
                                        if (_this.selectedTeilpaket && teilpaket.id == _this.selectedTeilpaket.id) {
                                            _this.selectedTeilpaket = teilpaket;
                                            _this.onTeilpaketSelect(teilpaket.id);
                                            break;
                                        }
                                    }
                                }
                            })
                                .catch(function (error) {
                                _this.snackBar.open("Es ist ein Fehler beim Laden der Teilpakete-Liste aufgetreten!", null, { duration: 3000, panelClass: ["bgc-red-400"] });
                                _this.errorHandling(error);
                            })];
                    case 1:
                        //this.kraftpakService.getTeilpakete().subscribe((teilpaketeAusDB) => {
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AppMaklerpaketKraft.prototype.paketAusListeEinspielen = function () {
        var _this = this;
        console.log("Das ausgewählte Teilpaket soll über ILK eingespielt werden!");
        if (this.selectedTeilpaket && !(this.paketBearbeitungDisabledFreigegeben && this.paketBearbeitungDisabledInFreigabe)) {
            this.csvUploadService.uploadMakpakKraftForCheck(this.selectedTeilpaket.id, this.selectedTeilpaket, this.userinfo.bensl, '/makpak/setorder')
                .subscribe(function (res) {
                pollUntilDone("/makpak/getresult", 1000, 10 * 60 * 1000, _this, true);
            }, function (error) {
                _this.snackBar.open("Es ist ein Fehler beim Einspielen des Teilpakets aufgetreten!", null, { duration: 2000, panelClass: ["bgc-red-400"] });
                _this.errorHandling(error);
            });
        }
    };
    AppMaklerpaketKraft.prototype.longestValueOfCol = function (colName) {
        var longest = -1;
        this._teilpakete.forEach(function (value) {
            try {
                var length_1 = value[colName].length;
                longest = length_1 > longest ? length_1 : longest;
            }
            catch (ignored) {
            }
        });
        //let lengthHeader = colName.length;
        //(lengthHeader > longest) ? longest = lengthHeader : longest = longest;
        return longest > 100 ? 100 : longest;
    };
    AppMaklerpaketKraft.prototype.loadTeilpaketDetails = function (teilpaketId) {
        var _this = this;
        //this.snackBar.open("Teilpaket wird geladen!", null, {duration: 1000, panelClass: ["bgc-green-400"]});
        this.kraftpakService.getLatestTeilpaketHist(teilpaketId)
            .subscribe(function (result) {
            console.log("loadTeilpaketDetails - ausgeführt");
            if (JSON.stringify(result).length > 0) {
                if (JSON.stringify(result).indexOf("Datei ist in Arbeit") > -1) {
                    _this.snackBar.open("Teilpaket-Details werden bereits von einem anderen Anwender bearbeitet!", null, { duration: 8000, panelClass: ["bgc-red-400"] });
                    _this.userData.setBiproDataLoaded(true);
                    result.splice(result.length - 1, 1);
                }
                console.log("loadTeilpaketDetails - Details gefunden");
                _this._teilpaketDetails = result;
                _this.mode = _this.pageModes.mpDetail;
            }
            else {
                _this.snackBar.open("Teilpaket-Details können nicht geladen werden!", null, { duration: 2000, panelClass: ["bgc-red-400"] });
            }
        }, function (error) {
            var errorMessageDefault = "Es ist ein Fehler beim Laden der Teilpaket-Details aufgetreten!";
            try {
                var errorMessageBackend = JSON.parse(error._body).Message.string;
                if (errorMessageBackend)
                    errorMessageDefault = errorMessageDefault + " " + errorMessageBackend;
            }
            catch (e) {
                console.log(e);
            }
            _this.snackBar.open(errorMessageDefault, null, { duration: 3000, panelClass: ["bgc-red-400"] });
            _this.errorHandling(error);
        });
    };
    AppMaklerpaketKraft.prototype.loescheTeilpaketAusListe = function (teilpaketId) {
        var _this = this;
        console.log("wir löschen jetzt " + teilpaketId);
        this.kraftpakService.deleteTeilPaket(teilpaketId)
            .subscribe(function (result) {
            if (result != null) {
                _this.paketBearbeitungDisabled = true;
                _this.paketLoeschenDisabled = true;
                _this.paketBearbeitungDisabledPruefOk = true;
                _this.paketBearbeitungDisabledInFreigabe = true;
                _this.paketBearbeitungDisabledFreigegeben = true;
                _this.loadTeilpakete(false);
                _this.selectedTeilpaket = null;
            }
        }, function (error) {
            var errorMessageDefault = "Es ist ein Fehler beim Löschen des Teilpakets aufgetreten!";
            try {
                var errorMessageBackend = JSON.parse(error._body).Message.string;
                if (errorMessageBackend)
                    errorMessageDefault = errorMessageDefault + " " + errorMessageBackend;
            }
            catch (e) {
                console.log(e);
            }
            _this.snackBar.open(errorMessageDefault, null, { duration: 3000, panelClass: ["bgc-red-400"] });
            _this.errorHandling(error);
        });
    };
    AppMaklerpaketKraft.prototype.changeDone = function (elementid) {
        if (!document.getElementById(elementid).classList.contains("ng-invalid")) {
            this.displayDialog = true;
        }
    };
    AppMaklerpaketKraft.prototype.paketNichtSpeichern = function () {
        this.displayDialog = false;
        this.paketBearbeitungDisabled = true;
        this.paketLoeschenDisabled = true;
        this.paketBearbeitungDisabledPruefOk = true;
        this.paketBearbeitungDisabledInFreigabe = true;
        this.paketBearbeitungDisabledFreigegeben = true;
        this.loadTeilpakete(false);
        //this.selectedTeilpaket = null;
    };
    AppMaklerpaketKraft.prototype.paketSpeichern = function () {
        var _this = this;
        console.log("Speichern der Änderungen für Paket " + this.selectedTeilpaket.id);
        this.kraftpakService.updateTeilpaket(this.selectedTeilpaket)
            .subscribe(function (result) {
            if (result != null) {
                _this.paketBearbeitungDisabled = true;
                _this.paketLoeschenDisabled = true;
                _this.paketBearbeitungDisabledPruefOk = true;
                _this.paketBearbeitungDisabledInFreigabe = true;
                _this.paketBearbeitungDisabledFreigegeben = true;
                _this.loadTeilpakete(false);
                //this.selectedTeilpaket = null;
                _this.displayDialog = false;
            }
        }, function (error) {
            var errorMessageDefault = "Es ist ein Fehler beim Speichern der geänderten Paketinformationen aufgetreten!";
            try {
                var errorMessageBackend = JSON.parse(error._body).Message.string;
                if (errorMessageBackend)
                    errorMessageDefault = errorMessageDefault + " " + errorMessageBackend;
            }
            catch (e) {
                console.log(e);
            }
            _this.snackBar.open(errorMessageDefault, null, { duration: 3000, panelClass: ["bgc-red-400"] });
            _this.errorHandling(error);
        });
    };
    AppMaklerpaketKraft.prototype.paketUpdateStatus = function (status) {
        var _this = this;
        this.kraftpakService.updateTeilpaketStatus(this.selectedTeilpaket.id, status, this.userinfo.bensl)
            .subscribe(function (result) {
            if (result != null) {
                _this.paketBearbeitungDisabled = true;
                _this.paketLoeschenDisabled = true;
                _this.paketBearbeitungDisabledPruefOk = true;
                _this.paketBearbeitungDisabledInFreigabe = true;
                _this.paketBearbeitungDisabledFreigegeben = true;
                _this.loadTeilpakete(false);
                //this.selectedTeilpaket = null;
                _this.displayDialog = false;
            }
        }, function (error) {
            var errorMessageDefault = "Es ist ein Fehler beim Aktualisieren des Teilpaket-Status aufgetreten!";
            try {
                var errorMessageBackend = JSON.parse(error._body).Message.string;
                if (errorMessageBackend)
                    errorMessageDefault = errorMessageDefault + " " + errorMessageBackend;
            }
            catch (e) {
                console.log(e);
            }
            _this.snackBar.open(errorMessageDefault, null, { duration: 3000, panelClass: ["bgc-red-400"] });
            _this.errorHandling(error);
        });
    };
    return AppMaklerpaketKraft;
}());
export { AppMaklerpaketKraft };
